.dropdown {
  --ixf-dropdown-border-color: var(--ixf-color-separator);
  --ixf-dropdown-background: var(--ixf-color-background);
  --ixf-dropdown-item-padding: var(--ixf-space-2);
  --ixf-dropdown-group-padding: var(--ixf-space-3);
  --ixf-dropdown-highlight-color: var(--ixf-color-neutral-xlt);
  --ixf-dropdown-item-font-size: 0.875rem;
  --ixf-dropdown-item-font-weight: var(--ixf-font-weight-main-medium);
  --ixf-dropdown-item-line-height: 1rem;
  --ixf-dropdown-group-font-size: 0.75rem;
  --ixf-dropdown-group-line-height: 1.5rem;
  --ixf-dropdown-group-letter-spacing: 1px;

  user-select: none;
  background: var(--ixf-dropdown-background);
  border-radius: var(--ixf-dropdown-border-radius, var(--ixf-border-radius-2));
  overflow: unset;
  overflow-y: auto !important;
  overflow-x: hidden;
  z-index: 9999;
  padding: 0;
  box-shadow: var(--ixf-box-shadow-dropdown);
  overscroll-behavior-y: contain;

  &[hidden] {
    display: none;
  }

  a,
  button:not(:disabled) {
    cursor: pointer;
  }

  &:hover {
    .item.isSelected:not(:hover),
    .item.isHighlighted:not(:hover),
    .item:focus-within:not(:hover),
    .item:focus:not(:hover) {
      background: var(--ixf-dropdown-background);
    }
  }

  .paddedItem {
    &:first-child {
      margin-top: var(--ixf-space-1);
    }

    &:last-child {
      margin-bottom: var(--ixf-space-1);
    }
  }

  .fullWidth {
    width: 100%;
  }

  .item {
    --ixf-dropdown-item-font-color: var(
      --ixf-dropdown-menu-list-item-color,
      var(--ixf-text-tone-md)
    );

    display: flex;
    width: calc(100% - var(--ixf-space-2));
    color: var(--ixf-dropdown-item-font-color);
    padding: var(--ixf-dropdown-item-padding);
    font-size: var(--ixf-dropdown-item-font-size);
    line-height: var(--ixf-dropdown-item-line-height);
    font-weight: var(--ixf-dropdown-item-font-weight);
    border-radius: var(--ixf-dropdown-item-border-radius, var(--ixf-space-1));
    overflow: hidden;
    flex: 0 0 auto;
    margin: 0 var(--ixf-space-1);

    &.hasPill {
      --ixf-dropdown-item-padding: 6px var(--ixf-space-2);
    }

    &.hasIcon {
      svg {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1rem;
      }
    }

    .prefix {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
    }

    .itemRow,
    .itemContent {
      flex: 1 1 auto;
      min-width: 0;
    }

    .suffix {
      display: inline-flex;
      flex-shrink: 0;
      align-items: center;
    }

    &.isHighlighted,
    &.isSelected {
      background: var(--ixf-dropdown-highlight-color);
    }

    &.isInteractive {
      &:hover,
      &:focus-within,
      &:focus {
        background: var(--ixf-dropdown-highlight-color);
      }
    }

    &:focus {
      outline: none;
    }

    .itemText {
      overflow: hidden;
    }

    .itemLabel {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      flex: 1;
    }

    .option {
      font-size: var(--ixf-dropdown-item-font-size);
      line-height: var(--ixf-dropdown-item-line-height);
      font-weight: var(--ixf-dropdown-item-font-weight);
      color: var(--ixf-dropdown-item-font-color);
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
      overflow: hidden;
      flex: 1;
    }

    &.endOfGroupBorder {
      border-bottom: 1px solid var(--ixf-dropdown-border-color);
    }
  }

  .group {
    .heading {
      padding: var(--ixf-dropdown-group-padding);
      font-size: var(--ixf-dropdown-group-font-size);
      line-height: var(--ixf-dropdown-group-line-height);
      letter-spacing: var(--ixf-dropdown-group-letter-spacing);
    }

    &.withBorder {
      border-bottom: 1px solid var(--ixf-dropdown-border-color);
    }
  }

  .noMatchingOptions,
  .pendingPagination {
    padding: var(--ixf-dropdown-item-padding);
  }

  .noMatchingOptions {
    .noOptionsMessage {
      color: var(--ixf-color-neutral-dk);
      font-size: var(--ixf-dropdown-item-font-size);
      line-height: var(--ixf-dropdown-item-line-height);
    }
  }
}

.hideOverflow {
  overflow: hidden;
}
